import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Button from '@Components/Button';
import DialogsWithIcon from '../DialogsWithIcon';

import './DialogWithInfoLayout.custom.scss';

export default function DialogWithNotificationInfoLayout(props) {
  // eslint-disable-next-line react/prop-types
  const { character, children, selfClose, onYesClick, footerClassName, yesLabel } = props;

  const clickHandler = () => {
    selfClose();
    if (onYesClick) {
      onYesClick();
    }
  };

  return (
    <DialogsWithIcon
      {...props}
      character={character}
      layoutType="info"
      headerClassName="dialog-with-info-layout-header"
      footerClassName={classnames(footerClassName, 'dialog-with-info-layout-footer-wrapper')}
      footer={
        <div className="els-btn-group-right">
          <Button
            buttonConfig={{ type: 'primary', size: 'sm', label: yesLabel, e2eName: 'dialog-ok' }}
            iconConfig={{ name: 'chevron-right', size: 'tiny' }}
            onClick={clickHandler}
          />
        </div>
      }>
      {children}
    </DialogsWithIcon>
  );
}

DialogWithNotificationInfoLayout.defaultProps = {
  character: '!',
  yesLabel: 'Ok',
};

DialogWithNotificationInfoLayout.propTypes = {
  selfClose: PropTypes.func.isRequired,
  onYesClick: PropTypes.func,
  yesLabel: PropTypes.string,
  character: PropTypes.string,
  children: PropTypes.node,
};
